import { render, staticRenderFns } from "./refundDetailDialogCust.vue?vue&type=template&id=2184aa30&scoped=true&"
import script from "./refundDetailDialogCust.vue?vue&type=script&lang=js&"
export * from "./refundDetailDialogCust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184aa30",
  null
  
)

export default component.exports